/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptTimeSlot } from '../models/V3StackAdaptTimeSlot';
import { HttpFile } from '../http/http';

/**
* Hourly parting for a StackAdapt campaign flight
*/
export class V3StackAdaptHourlyParting {
    /**
    * Whether hourly parting is enabled
    */
    'enabled'?: boolean;
    /**
    * Time slots to run the campaign
    */
    'timeSlots'?: Array<V3StackAdaptTimeSlot>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "timeSlots",
            "baseName": "timeSlots",
            "type": "Array<V3StackAdaptTimeSlot>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptHourlyParting.attributeTypeMap;
    }

    public constructor() {
    }
}

